import { z } from "zod";
import * as directoryScheme from "./directoryScheme";
import * as fileSchema from "./fileSchema";
import * as ReleasesType from "../../../types/releasesType";

export const nameHelper =
  "Release name is required. It must have at least 2 characters, max 300 characters, no special characters allowed";
export const nameSchema = directoryScheme.createNameSchema({
  name: "Release Name",
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});
export const bomFileHelper = fileSchema.fileSchemaHelper;
export const bomFileSchema = fileSchema.createFileSchema().optional();

export const typeHelper =
  "Release type is required. Please choose either Frame, Bulk, or Buyout";
// export const typeSchema = z.enum(ReleasesType.relTypes);

export const scopeHelper =
  "Release scope is required. Please choose either Standard, PMU, or VMU";
// export const scopeSchema = z.enum(ReleasesType.scopes);

export const notesHelper = directoryScheme.createTextFieldHelperText({
  name: "Notes",
  minLength: 0,
  maxLength: 10000,
  required: false,
  allowNumbers: true,
  allowSpecialChars: true,
});

export const notesSchema = directoryScheme.createTextFieldSchema({
  name: "Notes",
  minLength: 0,
  maxLength: 10000,
  required: false,
  allowNumbers: true,
  allowSpecialChars: true,
});

export const dateHelper =
  "Date is required. Please choose a date (YYYY-MM-DD). default is today";
export const dateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, {
    message: "Date must be in the format YYYY-MM-DD",
  })
  .default(new Date().toISOString().split("T")[0])
  .optional();

export const teamHelper =
  "Team is required. Please choose either Karas or Partner";
// export const teamSchema = z.enum(ReleasesType.teams);
